// ==== RATES ====
// Pesos en KG. Precios en USD salvo MX (MXN). Elige SIEMPRE el método más barato si hay varios.
const RATES = {
  MX: { // México: envío gratis 0–5 kg
    currency: 'MXN',
    methods: [
      { name: 'Shipping Mexico', tiers: [ { maxKg: 5, price: 0 } ] }
    ]
  },

  // United States unificado (usando tus tarifas de "U.S. Zona 3")
  US: {
    currency: 'USD',
    methods: [
      { name: 'DHL/FedEx Economy', tiers: [
        { maxKg: 0.35,   price: 20 },
        { maxKg: 3,   price: 35 },
        { maxKg: 4,   price: 50 },
        { maxKg: 5,   price: 55 },
        { maxKg: 999, price: 60 }
      ] }
    ]
  },

  ASIA: {
    currency: 'USD',
    methods: [
      { name: 'DHL/FedEx Economy', tiers: [
        { maxKg: 1,   price: 40 },
        { maxKg: 2,   price: 50 },
        { maxKg: 3,   price: 60 },
        { maxKg: 4,   price: 75 },
        { maxKg: 5,   price: 85 }
      ] }
    ]
  },

  // Worldwide por zonas
  ZONA_A: {
    currency: 'USD',
    methods: [
      { name: 'DHL/FedEx Economy', tiers: [
        { maxKg: 2.9, price: 35 },
        { maxKg: 3.9, price: 40 },
        { maxKg: 4.9, price: 45 },
        { maxKg: 999, price: 55 }
      ] },
      { name: 'MexPost (4–6 weeks)', tiers: [
        { maxKg: 2.9, price: 30 }
      ] }
    ]
  },
  ZONA_B: {
    currency: 'USD',
    methods: [
      { name: 'DHL/FedEx Economy', tiers: [
        { maxKg: 2.9, price: 40 },
        { maxKg: 3.9, price: 45 },
        { maxKg: 4.9, price: 55 },
        { maxKg: 999, price: 70 }
      ] },
      { name: 'MexPost (4–6 weeks)', tiers: [
        { maxKg: 1.9, price: 35 }
      ] }
    ]
  },
  ZONA_C: {
    currency: 'USD',
    methods: [
      { name: 'DHL/FedEx Economy', tiers: [
        { maxKg: 2.9, price: 65 },
        { maxKg: 3.9, price: 75 },
        { maxKg: 4.9, price: 85 },
        { maxKg: 999, price: 100 }
      ] },
      { name: 'DHL/FedEx Priority', tiers: [
        { maxKg: 2.9, price: 90 },
        { maxKg: 3.9, price: 100 },
        { maxKg: 4.9, price: 115 },
        { maxKg: 999, price: 130 }
      ] }
    ]
  }
};

// ==== utils ====
function money(n, c='USD', l='en-US') {
  try { return new Intl.NumberFormat(l, { style:'currency', currency:c }).format(n); }
  catch { return `${c} ${(+n).toFixed(2)}`; }
}

async function getCartWeightKg() {
  const r = await fetch('/cart.js', { credentials: 'same-origin' });
  const cart = await r.json();
  let grams = 0;
  (cart.items || []).forEach(it => grams += (it.grams || 0) * (it.quantity || 1));
  return grams / 1000;
}

function bestRateFor(zoneKey, kg) {
  const zone = RATES[zoneKey];
  if (!zone) return null;
  let best = null;

  zone.methods.forEach(m => {
    const tier = m.tiers.find(t => kg <= t.maxKg);
    if (!tier) return;
    const option = { zone: zoneKey, method: m.name, price: tier.price, currency: zone.currency || 'USD' };
    if (best === null || option.price < best.price) best = option;
  });

  return best;
}

function bestWorldwide(kg) {
  const candidates = ['ZONA_A','ZONA_B','ZONA_C']
    .map(key => bestRateFor(key, kg))
    .filter(Boolean);
  if (!candidates.length) return null;
  return candidates.reduce((a, b) => (b.price < a.price ? b : a));
}

// ==== render ====
async function updateSelection(forceDefaultUS = false) {
  const sel = document.getElementById('fixed-ship-country');
  const out = document.getElementById('fixed-ship-quote');
  if (!sel || !out) return;

  // Asegurar US por defecto si lo pediste
  if (forceDefaultUS) sel.value = 'US';

  out.textContent = 'Calculating…';

  const kg = await getCartWeightKg();
  const key = sel.value;

  let quote = null;
  if (key === 'WORLD_AUTO') {
    quote = bestWorldwide(kg);
  } else {
    quote = bestRateFor(key, kg);
  }

  if (!quote) { out.textContent = '—'; return; }

  const locale = (key === 'MX' && (quote.currency || 'USD') === 'MXN') ? 'es-MX' : 'en-US';
  out.textContent = (quote.price === 0)
    ? 'Free'
    : money(quote.price, quote.currency || 'USD', locale);
}

function initMinimalCalculator() {
  const sel = document.getElementById('fixed-ship-country');
  if (!sel) return false;

  // Forzamos el default a US en el primer render (por si el HTML no lo aplicó)
  updateSelection(true);

  // Recalcular al cambiar país y al modificar cantidades
  sel.addEventListener('change', () => updateSelection(false));
  document.addEventListener('change', (e) => {
    if (e.target && e.target.name === 'updates[]') setTimeout(() => updateSelection(false), 400);
  });
  return true;
}

document.addEventListener('DOMContentLoaded', () => {
  if (initMinimalCalculator()) return;
  let tries = 0, max = 20;
  const iv = setInterval(() => { tries++; if (initMinimalCalculator() || tries >= max) clearInterval(iv); }, 150);
});
